import {
  LocalizationProvider,
  DateField as MuiDateField,
  DateFieldProps as MuiDateFieldProps,
  PickerValidDate,
} from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ptBR } from 'date-fns/locale'
import { forwardRef } from 'react'

type DateFieldProps = MuiDateFieldProps & {
  value?: PickerValidDate | null
  onChange: (value: PickerValidDate | null) => void
}

export const DateField = forwardRef<HTMLInputElement, DateFieldProps>(
  (props, ref) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <MuiDateField {...props} inputRef={ref} timezone="UTC" />
      </LocalizationProvider>
    )
  },
)
